import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Baseproperties } from 'src/app/views/utility/baseproperties';
import { City } from '../../utility/modals';

@Injectable({
  providedIn: 'root'
})
export class CityService {

  
  baseproperties: Baseproperties = new Baseproperties(); 

    private baseURL = this.baseproperties.gatewayBaseURL+"/common"
    scrollHeight: string = '22em'; 
    constructor(private httpClient: HttpClient,private route:Router) { }
    //DepartmentService
  
  getOptionDropdown(length):Array<any>{
    let options=[]
    let pairSize = 10;
    let numberOfPairs = Math.ceil(length / pairSize);   // Calculate the number of pairs
    let pairsArray = Array.from({ length: numberOfPairs }, (_, index) => {
      const end = Math.min((index + 1) * pairSize, length); // Create the array of pairs
      return [end];
    });
    pairsArray.map((e)=>{
      options.push({'label':e[0],value:e[0]})
    });
    return options
  }
  
  //Add New City
  addCity(city): Observable<Object>{
    return this.httpClient.post(`${this.baseURL}/gen/addcity`, city);
  }
  getCityById(id: number, number: any): Observable<City>{
    return this.httpClient.get<City>(`${this.baseURL}/gen/getcitybyid/${id}`);
  }
  updateCity(city: City): Observable<Object>{
    return this.httpClient.post(`${this.baseURL}/gen/modifycity`, city);
    }
    getCityData(): Observable<any> {
        return this.httpClient.get(`${this.baseURL}/gen/viewcity`);
      }
      cityDataExcel()
  {
  
     return this.httpClient.get(`${this.baseURL}/gen/citydataexcel`,{ responseType: 'blob' }); 
  }
}
